export const componentStyles = {
  logo: {
    width: "247px",
    height: "66px",
    cursor: "pointer",
  },
  drawerIcon: { width: "70px", height: "70px", cursor: "pointer", borderRadius: "50%" },
  padding: { padding: "20px 40px" },
  headerStyle: {
    backgroundColor: "#f3fdff",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    boxShadow: "0px 4px 4px 0px #00000040",
    marginBottom: "10px"
  }
};
